import { OrbitControls } from "@react-three/drei"
import { Canvas, useFrame, useThree } from "@react-three/fiber"
import { Suspense } from "react"
import * as THREE from 'three'
import gsap from "gsap"

import Cylinder from "./Cylinder"
import Effects from "./Effects"
import Floor from "./Floor"
import Lights from "./Lights"
import Model from "./Model"
import TextMesh from "./TextMesh"
import Point from "./Point"

THREE.ColorManagement.legacyMode = false

const CameraMesh = ({enableControls}) =>
{   
    useThree(({camera})=>{
        if(enableControls){
            gsap.to(camera.position, {duration: 1, x:0, y:0, z:2})
        }
    })

    return null
}

const Experience = ({enableControls}) =>
{
    return(
        <Canvas gl={{ alpha: false, outputEncoding: THREE.LinearEncoding }} camera={ { position: [0.75, 0, 0.2] } }>
            <color attach="background" args={['#000033']} />

            <Model />

            <Floor />

            <Cylinder enableControls={enableControls} />
            <Point position={[1, 0.5, 0]} />

            <CameraMesh enableControls={enableControls} />
            <OrbitControls 
                minPolarAngle={Math.PI / 2.2} 
                maxPolarAngle={Math.PI / 1.8} 
                minDistance={0.8}
                maxDistance={0.8}
                panSpeed={3} 
            />
            <Lights enableControls={enableControls} />
            <Effects />
        </Canvas>
    )
}

export default Experience